var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4H6V5H5V6H4V8V10H5V11H6V12H8H10V11H11V10H12V8V6H11V5H10V4H8Z",
    fill: "#F5E06D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    width: 2,
    height: 1,
    fill: "#F5E06D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 1,
    width: 1,
    height: 2,
    fill: "#F5E06D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 15,
    width: 2,
    height: 1,
    fill: "#F5E06D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 7,
    width: 1,
    height: 2,
    fill: "#F5E06D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 7,
    width: 1,
    height: 2,
    fill: "#F5E06D"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 3,
    width: 2,
    height: 1,
    fill: "#F5E06D"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 13,
    width: 1,
    height: 2,
    fill: "#F5E06D"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 13,
    width: 1,
    height: 2,
    fill: "#F5E06D"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 1,
    transform: "matrix(1 0 0 -1 13 13)",
    fill: "#F5E06D"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 3,
    width: 2,
    height: 1,
    fill: "#F5E06D"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 1,
    width: 1,
    height: 2,
    fill: "#F5E06D"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 12,
    width: 2,
    height: 1,
    fill: "#F5E06D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.6316de21efea2e6ba8debcbde7dc42b1.svg";
export { ForwardRef as ReactComponent };